import { takeEvery, put, call } from "redux-saga/effects"
import {
  FETCH_WORKFLOW_CONFIG,
  SAVE_WORKFLOW_CONFIG,
  FETCH_ORDER_TRANSITIONS,
  EXECUTE_ORDER_TRANSITION,
} from "./actionTypes"
import {
  fetchWorkflowConfigSuccess,
  fetchWorkflowConfigFail,
  saveWorkflowConfigSuccess,
  saveWorkflowConfigFail,
  fetchOrderTransitionsSuccess,
  fetchOrderTransitionsFail,
  executeOrderTransitionSuccess,
  executeOrderTransitionFail,
} from "./actions"
import {
  getWorkflowConfig,
  updateWorkflowConfig,
  getOrderTransitions,
  executeTransition,
} from "../../helpers/api_helper"

function* onFetchWorkflowConfig() {
  try {
    const response = yield call(getWorkflowConfig)
    yield put(fetchWorkflowConfigSuccess(response))
  } catch (error) {
    yield put(fetchWorkflowConfigFail(error.message || "Failed to fetch workflow config"))
  }
}

function* onSaveWorkflowConfig({ payload }) {
  try {
    const { templateId, config } = payload
    const response = yield call(updateWorkflowConfig, templateId, config)
    yield put(saveWorkflowConfigSuccess(response))
  } catch (error) {
    yield put(saveWorkflowConfigFail(error.message || "Failed to save workflow config"))
  }
}

function* onFetchOrderTransitions({ payload: orderId }) {
  try {
    const response = yield call(getOrderTransitions, orderId)
    yield put(fetchOrderTransitionsSuccess(response))
  } catch (error) {
    yield put(fetchOrderTransitionsFail(error.message || "Failed to fetch transitions"))
  }
}

function* onExecuteOrderTransition({ payload }) {
  try {
    const { orderId, transitionId, options } = payload
    const response = yield call(executeTransition, orderId, transitionId, options)
    yield put(executeOrderTransitionSuccess(response))
  } catch (error) {
    yield put(executeOrderTransitionFail(error.message || "Failed to execute transition"))
  }
}

function* workflowSaga() {
  yield takeEvery(FETCH_WORKFLOW_CONFIG, onFetchWorkflowConfig)
  yield takeEvery(SAVE_WORKFLOW_CONFIG, onSaveWorkflowConfig)
  yield takeEvery(FETCH_ORDER_TRANSITIONS, onFetchOrderTransitions)
  yield takeEvery(EXECUTE_ORDER_TRANSITION, onExecuteOrderTransition)
}

export default workflowSaga
